import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { DatasetByIdProps, ProspectProps } from 'utils/types';

export const fileKey = ['prospects'];

const useProspects = () => useQuery<ProspectProps[]>({
  queryKey: fileKey,
  queryFn: async () => {
    const isOffline = localStorage.getItem('netStatus') === 'offline';
    
    try {
      if (isOffline) {
        const stringifiedProspects = localStorage.getItem('prospects');
        const prospects = JSON.parse(stringifiedProspects || '[]') as ProspectProps[];

        return prospects;
      } else {
        const response = await agent.getClient()('prospect?limit=1000');
        const prospects = (response.data?.data || []) as ProspectProps[];
        localStorage.setItem('prospects', JSON.stringify(prospects));

        const detailsPromises = prospects
          .map((prospect) => agent.getClient()(`/prospect/dataset/${prospect.id}`)
            .then((response) => ({
              data: response.data as DatasetByIdProps,
              id: prospect.id,
            })));

        Promise.all(detailsPromises)
          .then((details) => {
            const detailsForStorage = details
              .reduce((store, detail) => ({ 
                ...store,
                [detail.id]: detail.data,
              }), {} as Record<string, any>);
            localStorage.setItem('prospect-details', JSON.stringify(detailsForStorage));
          })
          .catch((e) => console.error('Error while fetching prospect map details', e));
  
        return prospects;
      }
    } catch (e) {
      console.error(e);

      return [] as ProspectProps[];
    }
  },
});

export default useProspects;
